<template>
  <div id="subscription-payment-view"></div>
</template>

<script>
export default {
  name: "SubscriptionPaymentView",
  data() {
    return {};
  },
  async mounted() {
    this.open();
  },
  methods: {
    cancel() {
      alert("This is not a valid access.");
      location.href = "https://shadow.do";
    },
    open() {
      const urlParams = new URLSearchParams(window.location.search);

      if (this.checkQueryParams(urlParams)) {
        try {
          const prefilledPromoCode = urlParams.get("prefilled_promo_code");
          const clientReferenceId = urlParams.get("client_reference_id");
          const decodedClientReferenceId =
            this.base64UrlDecode(clientReferenceId);
          const jsonClientReferenceId = JSON.parse(decodedClientReferenceId);

          // 필수 키 확인
          const requiredKeys = ["email", "userUid", "planName", "linkId"];
          const missingKeys = requiredKeys.filter(
            (key) => !(key in jsonClientReferenceId)
          );

          if (missingKeys.length > 0) {
            throw new Error("Missing required key");
          }

          // 이메일 유효성 검사
          if (this.isValidEmail(jsonClientReferenceId.email) == false) {
            throw new Error("Invalid email format");
          }

          // 플랜명 확인 // TODO: 추후 늘어난다면 유효성 확인 필요
          if (jsonClientReferenceId.planName != "Plus") {
            throw new Error("Plan is not valid");
          }

          // UID 길이 확인
          if (jsonClientReferenceId.userUid.length != 28) {
            throw new Error("User UID is not valid");
          }

          let url = "https://buy.stripe.com/" + jsonClientReferenceId.linkId;
          let params = {
            prefilled_email: encodeURI(jsonClientReferenceId.email),
            client_reference_id: clientReferenceId,
          };

          if (prefilledPromoCode !== null) {
            params.prefilled_promo_code = prefilledPromoCode;
          }

          window.location.replace(url + "?" + new URLSearchParams(params));
        } catch (error) {
          console.error(error);

          alert("Invalid client reference ID");
          this.cancel();
        }
      } else {
        this.cancel();
      }
    },
    checkQueryParams(urlParams) {
      try {
        let isClientReferenceIdExist = urlParams.has("client_reference_id");
        if (!isClientReferenceIdExist)
          throw new Error("Client Reference ID is required");

        let clientReferenceId = urlParams.get("client_reference_id");

        if (clientReferenceId == "")
          throw new Error("Client Reference ID is empty");

        return true;
      } catch (error) {
        console.error(error);

        return false;
      }
    },
    base64UrlDecode(str) {
      // 1. URL-safe → 표준 Base64
      str = str.replace(/-/g, "+").replace(/_/g, "/");

      // 2. 패딩 복원 (길이를 4의 배수로 맞춤)
      const padLength = 4 - (str.length % 4);
      if (padLength < 4) {
        str += "=".repeat(padLength);
      }

      // 3. 디코딩
      return atob(str);
    },
    isValidEmail(email) {
      // 이메일 유효성 검사를 위한 정규식
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // 정규식으로 이메일 검증
      return emailRegex.test(email);
    },
  },
};
</script>
